import { render, staticRenderFns } from "./MostUsedForms.vue?vue&type=template&id=e8b8e904&scoped=true"
import script from "./MostUsedForms.vue?vue&type=script&lang=ts"
export * from "./MostUsedForms.vue?vue&type=script&lang=ts"
import style0 from "./MostUsedForms.vue?vue&type=style&index=0&id=e8b8e904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b8e904",
  null
  
)

export default component.exports